import { j as t } from "./jsx-runtime.DGlMoOmv.js";
import * as A from "react";
import { c as l } from "./index.CxSWpsOB.js";
import { S as O } from "./Spinner.Brgz0Lk4.js";
import { b as V } from "./button-variants.DWX6pG3S.js";
const z = A.forwardRef(({
  className: w,
  variant: e = "default",
  appearance: n = "black",
  size: a = "default",
  children: r,
  showSpinner: s,
  prefix: o,
  suffix: c,
  disabled: u,
  tabIndex: x,
  iconOnly: b,
  ariaLabel: j,
  testId: i = "ps-button",
  fullWidth: y,
  width: f,
  truncate: g,
  alignment: N = "center",
  shape: m = "default",
  href: p,
  ...h
}, k) => {
  const d = m !== "default" && e !== "ghost", B = d ? "white" : n, R = d ? "outline-1" : e, $ = () => n === "white" && ["default", "outline-1", "outline-2"].includes(e) || n === "black" && ["ghost", "text-only"].includes(e) ? "black" : n === "purple" && ["ghost", "text-only"].includes(e) ? "purple" : "white", v = p ? "a" : "button";
  return /* @__PURE__ */ t.jsxs(
    v,
    {
      ref: k,
      type: "button",
      className: l("focus:tw-outline", V({
        variant: R,
        appearance: B,
        size: a,
        disabled: !!u,
        prefix: !!o,
        suffix: !!c,
        iconOnly: !!b,
        showSpinner: !!s,
        fullWidth: !!y,
        shape: m,
        alignment: N,
        className: w
      })),
      style: f ? {
        width: f
      } : void 0,
      tabIndex: u || s ? -1 : x,
      "aria-disabled": u || s ? !0 : void 0,
      "aria-label": j || (typeof r == "string" ? r : void 0),
      "data-testid": i,
      href: p,
      ...h,
      children: [
        s && /* @__PURE__ */ t.jsx("span", { className: "tw-absolute tw-inset-0 tw-inline-flex tw-items-center tw-justify-center", children: /* @__PURE__ */ t.jsx(O, { size: a, appearance: $(), testId: `${i}-spinner` }) }),
        /* @__PURE__ */ t.jsxs("span", { className: l("tw-flex tw-items-center", {
          "tw-opacity-0": s,
          "tw-truncate": g
        }), children: [
          !!o && /* @__PURE__ */ t.jsx("span", { "data-testid": `${i}-prefix`, className: l("tw-flex tw-items-center tw-size-20 tw-mr-8", {
            "tw-size-24": a === "large"
          }), children: o }),
          r,
          !!c && /* @__PURE__ */ t.jsx("span", { "data-testid": `${i}-suffix`, className: l("tw-flex tw-items-center tw-size-20 tw-ml-8", {
            "tw-size-24": a === "large"
          }), children: c })
        ] })
      ]
    }
  );
});
z.displayName = "Button";
export {
  z as B
};
//# sourceMappingURL=Button.Ccj-dDdM.js.map
